var $684ee29aeedc24d0$exports = {};
$684ee29aeedc24d0$exports = {
    "loading": `Nalaganje ...`,
    "loadingMore": `Nalaganje ve\u{10D} vsebine ...`
};


export {$684ee29aeedc24d0$exports as default};
//# sourceMappingURL=sl-SI.mjs.map
